import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { Payment, PaymentType } from 'src/app/pay/models/payment.model';
import { AnalyticsEvent, AnalyticsService } from '../../../core/services/analytics-service';
import { DialogService } from '../../../core/services/dialog.service';
import { DisabledExpressPaymentDialogComponent } from '../disabled-express-payment-dialog/disabled-express-payment-dialog.component';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';

@Component({
standalone: false,
  selector: 'app-express-payment',
  styleUrls: ['./express-payment.component.scss'],
  templateUrl: './express-payment.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ExpressPaymentComponent {
  @Input() showRecommendation: boolean;
  @Input() payment: Payment;
  @Output() public expressPaymentChanged = new EventEmitter<boolean>();

  public PaymentType = PaymentType;

  constructor(private analyticsService: AnalyticsService, private dialog: DialogService) {
  }

  public toggleChange(event: MatSlideToggleChange): void {
    if (this.payment.disabledExpressPaymentLiabilities?.length > 0) {
      event.source.checked = false;
      this.dialog.open(DisabledExpressPaymentDialogComponent, {
        data: this.payment.disabledExpressPaymentLiabilities,
        closeOnNavigation: true,
        disableClose: false,
        width: '600px',
      });
    } else {
      if (event.checked) {
        this.payment.type = PaymentType.EXPRESS;
        this.analyticsService.trackEvent(new AnalyticsEvent('Express payment selected'));
      } else {
        this.payment.type = PaymentType.STANDARD;
      }

      this.expressPaymentChanged.next(event.checked);
    }
  }
}
